import * as stylex from '@stylexjs/stylex';
import { FC } from 'react';
import { styles } from '../../styles';
import { IconButton } from '@shared/ui/icon-button';
import { TrashIcon, DownloadIcon } from '@shared/assets/icons';
import { InfoIcon } from '@shared/assets/icons/info';
import { Tooltip } from '@shared/ui/tooltip';
import { colors } from '@shared/tokens/colors.stylex';
import { formatCheckInTime } from '@shared/libs/format-check-in-time';
import { Ticket } from '@pages/event/api/useFetchTicketSegment';
import { getScanTypeLabel } from '@features/participant-card-no-segment/lib/get-scan-type-label';

interface ParticipantActionsProps {
  ticket: Ticket;
  onDelete?: () => void;
  getTicketQR?: () => void;
  onInfoClick?: () => void;
}

export const ParticipantActions: FC<ParticipantActionsProps> = ({ ticket, onDelete, getTicketQR, onInfoClick }) => {
  const { date: checkInDate, time: checkInTime } = formatCheckInTime(ticket.checkInTime);

  return (
    <div {...stylex.props(styles.actions)}>
      <div {...stylex.props(styles.actionsIcon)}>
        <IconButton icon={<TrashIcon color={colors.tertiaryIcon} />} onClick={onDelete} />
      </div>

      <div {...stylex.props(styles.actionsIconStroke)}>
        <Tooltip
          position="topRight"
          title={
            <div {...stylex.props(styles.infoTooltip)}>
              <div {...stylex.props(styles.infoRow)}>
                <span {...stylex.props(styles.titleRow)}>Регистрация:</span>
                <span {...stylex.props(styles.statusRow)}>
                  {checkInDate !== '-' && checkInTime !== '-' ? `${checkInDate} в ${checkInTime}` : '-'}
                </span>
              </div>
              <div {...stylex.props(styles.infoRow)}>
                <span {...stylex.props(styles.titleRow)}>Регистратор:</span>
                <span {...stylex.props(styles.statusRow)}>{ticket.organizerName || '-'}</span>
              </div>
              <div {...stylex.props(styles.infoRow)}>
                <span {...stylex.props(styles.titleRow)}>Способ:</span>
                <span {...stylex.props(styles.statusRow)}>{getScanTypeLabel(ticket.scanType)}</span>
              </div>
            </div>
          }
        >
          <IconButton icon={<InfoIcon />} onClick={onInfoClick} />
        </Tooltip>
      </div>

      {getTicketQR && (
        <div {...stylex.props(styles.actionsIcon)}>
          <IconButton icon={<DownloadIcon />} onClick={getTicketQR} />
        </div>
      )}
    </div>
  );
};
